import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26d3a7be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-form" }
const _hoisted_2 = {
  key: 2,
  class: "info-box success-message"
}
const _hoisted_3 = { class: "form-items" }
const _hoisted_4 = ["disabled", "placeholder"]
const _hoisted_5 = {
  key: 1,
  class: "form-info"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = ["disabled", "placeholder"]
const _hoisted_8 = {
  key: 3,
  class: "form-info"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { class: "account" }
const _hoisted_15 = { key: 5 }

import {
    ComputedRef,
    computed,
    reactive,
    ref,
    toRefs,
    watch,
    withDefaults,
  } from 'vue'
  import { useRoute } from 'vue-router'

  import PasswordInput from '@/components/Common/PasswordInput.vue'
  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { ILoginRegisterFormData } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    action: string
    token?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    action: null,
    token: { default: '' }
  },
  setup(__props: any) {

const props = __props as { action: string, token: string }

  

  const route = useRoute()
  const store = useStore()

  const { action } = toRefs(props)
  const formData: ILoginRegisterFormData = reactive({
    username: '',
    email: '',
    password: '',
  })
  const buttonText: ComputedRef<string> = computed(() =>
    getButtonText(props.action)
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  const isRegistrationSuccess: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.IS_REGISTRATION_SUCCESS]
  )
  const isSuccess: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.IS_SUCCESS]
  )
  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  const registration_disabled: ComputedRef<boolean> = computed(
    () =>
      props.action === 'register' && !appConfig.value.is_registration_enabled
  )
  const sendingEmailDisabled: ComputedRef<boolean> = computed(
    () =>
      ['reset-request', 'account-confirmation-resend'].includes(props.action) &&
      !appConfig.value.is_email_sending_enabled
  )
  const formErrors = ref(false)

  function getButtonText(action: string): string {
    switch (action) {
      case 'reset-request':
      case 'reset':
        return 'buttons.SUBMIT'
      default:
        return `buttons.${props.action.toUpperCase()}`
    }
  }
  function invalidateForm() {
    formErrors.value = true
  }
  function updatePassword(password: string) {
    formData.password = password
  }
  function onSubmit(actionType: string) {
    switch (actionType) {
      case 'reset':
        if (!props.token) {
          return store.commit(
            ROOT_STORE.MUTATIONS.SET_ERROR_MESSAGES,
            'user.INVALID_TOKEN'
          )
        }
        return store.dispatch(AUTH_USER_STORE.ACTIONS.RESET_USER_PASSWORD, {
          password: formData.password,
          token: props.token,
        })
      case 'reset-request':
        return store.dispatch(
          AUTH_USER_STORE.ACTIONS.SEND_PASSWORD_RESET_REQUEST,
          {
            email: formData.email,
          }
        )
      case 'account-confirmation-resend':
        return store.dispatch(
          AUTH_USER_STORE.ACTIONS.RESEND_ACCOUNT_CONFIRMATION_EMAIL,
          {
            email: formData.email,
          }
        )
      default:
        store.dispatch(AUTH_USER_STORE.ACTIONS.LOGIN_OR_REGISTER, {
          actionType,
          formData,
          redirectUrl: route.query.from,
        })
    }
  }
  function resetFormData() {
    formData.username = ''
    formData.email = ''
    formData.password = ''
  }

  watch(
    () => route.path,
    async () => {
      store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES)
      store.commit(AUTH_USER_STORE.MUTATIONS.UPDATE_IS_SUCCESS, false)
      store.commit(
        AUTH_USER_STORE.MUTATIONS.UPDATE_IS_REGISTRATION_SUCCESS,
        false
      )
      formErrors.value = false
      resetFormData()
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_AlertMessage = _resolveComponent("AlertMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", {
    id: "user-auth-form",
    class: _normalizeClass(`${
      ['reset', 'reset-request'].includes(_unref(action)) ? _unref(action) : 'user-form'
    }`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-box", {
          disabled: _unref(registration_disabled),
        }])
      }, [
        (_unref(registration_disabled))
          ? (_openBlock(), _createBlock(_component_AlertMessage, {
              key: 0,
              message: "user.REGISTER_DISABLED"
            }))
          : _createCommentVNode("", true),
        (_unref(sendingEmailDisabled))
          ? (_openBlock(), _createBlock(_component_AlertMessage, {
              key: 1,
              message: "admin.EMAIL_SENDING_DISABLED"
            }))
          : _createCommentVNode("", true),
        (_unref(isSuccess) || _unref(isRegistrationSuccess))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(
              `user.PROFILE.SUCCESSFUL_${
                _unref(isRegistrationSuccess)
                  ? `REGISTRATION${
                      _unref(appConfig).is_email_sending_enabled ? '_WITH_EMAIL' : ''
                    }`
                  : 'UPDATE'
              }`
            )), 1))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          class: _normalizeClass({ errors: formErrors.value }),
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onSubmit(_unref(action))), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(action) === 'register')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: "username",
                  disabled: _unref(registration_disabled),
                  required: "",
                  pattern: "[a-zA-Z0-9_]+",
                  minlength: "3",
                  maxlength: "30",
                  onInvalid: invalidateForm,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).username) = $event)),
                  placeholder: _ctx.$t('user.USERNAME')
                }, null, 40, _hoisted_4)), [
                  [_vModelText, _unref(formData).username]
                ])
              : _createCommentVNode("", true),
            (_unref(action) === 'register')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('user.USERNAME_INFO')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(action) !== 'reset')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 2,
                  id: "email",
                  disabled: _unref(registration_disabled) || _unref(sendingEmailDisabled),
                  required: "",
                  onInvalid: invalidateForm,
                  type: "email",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).email) = $event)),
                  placeholder: _ctx.$t('user.EMAIL')
                }, null, 40, _hoisted_7)), [
                  [_vModelText, _unref(formData).email]
                ])
              : _createCommentVNode("", true),
            (
                [
                  'reset-request',
                  'register',
                  'account-confirmation-resend',
                ].includes(_unref(action))
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('user.EMAIL_INFO')), 1)
                ]))
              : _createCommentVNode("", true),
            (
                !['account-confirmation-resend', 'reset-request'].includes(
                  _unref(action)
                )
              )
              ? (_openBlock(), _createBlock(PasswordInput, {
                  key: 4,
                  disabled: _unref(registration_disabled),
                  required: true,
                  placeholder: 
                _unref(action) === 'reset'
                  ? _ctx.$t('user.ENTER_PASSWORD')
                  : _ctx.$t('user.PASSWORD')
              ,
                  password: _unref(formData).password,
                  checkStrength: ['reset', 'register'].includes(_unref(action)),
                  onUpdatePassword: updatePassword,
                  onPasswordError: invalidateForm
                }, null, 8, ["disabled", "placeholder", "password", "checkStrength"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "submit",
            disabled: _unref(registration_disabled) || _unref(sendingEmailDisabled)
          }, _toDisplayString(_ctx.$t(_unref(buttonText))), 9, _hoisted_10)
        ], 34),
        (_unref(action) === 'login')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "links",
                to: "/register"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('user.REGISTER')), 1)
                ]),
                _: 1
              }),
              (_unref(appConfig).is_email_sending_enabled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                : _createCommentVNode("", true),
              (_unref(appConfig).is_email_sending_enabled)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "links",
                    to: "/password-reset/request"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('user.PASSWORD_FORGOTTEN')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(action) === 'register')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('user.ALREADY_HAVE_ACCOUNT')), 1),
              _createVNode(_component_router_link, {
                class: "links",
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('user.LOGIN')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (
            ['login', 'register'].includes(_unref(action)) &&
            _unref(appConfig).is_email_sending_enabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_router_link, {
                class: "links",
                to: "/account-confirmation/resend"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('user.ACCOUNT_CONFIRMATION_NOT_RECEIVED')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(errorMessages))
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 6,
              message: _unref(errorMessages)
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 2))
}
}

})